import Link from 'next/link';
import type { NextRouter } from 'next/router';

import { Pill } from '@/components/menuV2/Pill/Pill';
import type { MenuHierarchyRecordModelType } from '@/models/api';

interface ICategoryLinks {
  path: string;
  links: MenuHierarchyRecordModelType[];
  router: NextRouter;
}

export const CategoryLinks: React.FC<ICategoryLinks> = ({
  path,
  links,
  router,
}) => {
  const { code, mode } = router.query;
  return (
    <div className="hide-scroll flex max-w-[765px] space-x-3.5 overflow-x-scroll pb-4 lg:space-x-5 lg:pb-6 xl:max-w-fit">
      {links.map((item, index) => {
        const link = `/menu/${item.slug}`;
        const style = index > 1 ? 'flex-none min-w-[24%] md:min-w-fit' : '';
        return (
          <Link
            key={item.name}
            className={`shrink-0 grow-0 font-interSemibold ${style}`}
            href={{
              pathname: link,
              query: {
                ...(mode && { mode }),
                ...(code && { code }),
              },
            }}
          >
            <Pill
              index={index}
              name={item.name || ''}
              isActive={path === item.slug}
              image={item.image}
            />
          </Link>
        );
      })}
    </div>
  );
};
